// import { API_HOST, HZERO_PLATFORM } from 'utils/config';

/**
 * 获取某个子模块加载的 PublicUrl
 * @param moduleName 子模块名, 如果为空，则表示获取 模块列表配置文件的 PublicUrl
 */
function getMicroPublicUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$moduleName = _ref.moduleName,
    moduleName = _ref$moduleName === void 0 ? '' : _ref$moduleName,
    _ref$microModuleScrip = _ref.microModuleScriptMap,
    microModuleScriptMap = _ref$microModuleScrip === void 0 ? window.microModuleScriptMap : _ref$microModuleScrip;
  var microPackagePublicUrl = process.env.PUBLIC_URL || '/';
  if (window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__) {
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
    microPackagePublicUrl = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
  }
  if (moduleName) {
    if (window.dvaApp && window.dvaApp._store || microModuleScriptMap) {
      var _microModuleScriptMap = microModuleScriptMap || (window.dvaApp._store.getState().microModule || {
        microModuleScriptMap: {}
      }).microModuleScriptMap;
      var moduleConfig = _microModuleScriptMap[moduleName];
      if (moduleConfig && moduleConfig.publicUrl) {
        microPackagePublicUrl = moduleConfig.publicUrl;
      }
    } else {
      var _ref2, _ref2$currentScript;
      var currentScriptSrc = (_ref2 = document) === null || _ref2 === void 0 ? void 0 : (_ref2$currentScript = _ref2.currentScript) === null || _ref2$currentScript === void 0 ? void 0 : _ref2$currentScript.src;
      if (currentScriptSrc) {
        microPackagePublicUrl = currentScriptSrc.replace(/(https?:\/\/[^\/]*\/|\/).*/, '$1') || '/';
      }
    }
  }
  if (!microPackagePublicUrl.startsWith('/') && !microPackagePublicUrl.startsWith('http')) {
    microPackagePublicUrl = "/".concat(microPackagePublicUrl);
  }
  if (!microPackagePublicUrl.endsWith('/')) {
    microPackagePublicUrl = "".concat(microPackagePublicUrl, "/");
  }
  return microPackagePublicUrl;
}
export function getExternalMicroPublicUrlList() {
  if (!window.PACKAGE_PUBLIC_URLS) {
    (function () {
      if (!window.PACKAGE_PUBLIC_URL && process.env.PACKAGE_PUBLIC_URL) {
        var PACKAGE_PUBLIC_URL = process.env.PACKAGE_PUBLIC_URL;
        var _PACKAGE_PUBLIC_URLS = [];
        if (PACKAGE_PUBLIC_URL) {
          try {
            if (PACKAGE_PUBLIC_URL.startsWith('[')) {
              _PACKAGE_PUBLIC_URLS = JSON.parse(PACKAGE_PUBLIC_URL);
              if (typeof _PACKAGE_PUBLIC_URLS === 'string') {
                _PACKAGE_PUBLIC_URLS = [_PACKAGE_PUBLIC_URLS];
              }
            } else {
              _PACKAGE_PUBLIC_URLS = PACKAGE_PUBLIC_URL.replace(/"/g, '').split(',');
            }
          } catch (e) {
            console.log(e);
            _PACKAGE_PUBLIC_URLS = PACKAGE_PUBLIC_URL.replace(/"/g, '').split(',');
          }
        }
        window.PACKAGE_PUBLIC_URLS = _PACKAGE_PUBLIC_URLS;
      }
    })();
  }
  var PACKAGE_PUBLIC_URLS = window.PACKAGE_PUBLIC_URLS || [];
  return PACKAGE_PUBLIC_URLS.map(function (url) {
    var microPackagePublicUrl = url || '/';
    if (!microPackagePublicUrl.startsWith('/') && !microPackagePublicUrl.startsWith('http')) {
      microPackagePublicUrl = "/".concat(microPackagePublicUrl);
    }
    if (!microPackagePublicUrl.endsWith('/')) {
      microPackagePublicUrl = "".concat(microPackagePublicUrl, "/");
    }
    return microPackagePublicUrl;
  });
}
export default getMicroPublicUrl;